import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';

const TokenAccess = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [completed, setCompleted] = useState(false);
  const [submittedAt, setSubmittedAt] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      try {
        console.log('Validating token:', token);
        const res = await axios.get(`/api/session/token/${token}`);

        if (res.data.completed) {
          // Show already completed page
          setCompleted(true);
          setSubmittedAt(res.data.submitted_at);
          setLoading(false);
        } else if (res.data.valid) {
          // Redirect to form with pre-fill data
          console.log('Token valid, redirecting to form with data:', res.data.kit_data);
          navigate('/form', {
            state: {
              sessionId: res.data.session_id,
              prefillData: res.data.kit_data,
              savedResponses: res.data.saved_responses,
              resumed: res.data.resumed,
              fromToken: true
            }
          });
        } else {
          setError(res.data.error || res.data.message || 'Invalid link');
          setLoading(false);
        }
      } catch (err) {
        console.error('Token validation error:', err);
        if (err.response?.status === 410) {
          setError('This questionnaire link has expired (30 days limit).');
        } else if (err.response?.status === 404) {
          setError('Invalid questionnaire link.');
        } else {
          setError(err.response?.data?.message || 'Invalid or expired questionnaire link');
        }
        setLoading(false);
      }
    };

    validateToken();
  }, [token, navigate]);

  if (loading) {
    return (
      <div className="token-access-container">
        <div className="token-access-card">
          <div className="loading-spinner"></div>
          <h2>Validating your questionnaire link...</h2>
          <p>Please wait while we verify your access.</p>
        </div>
      </div>
    );
  }

  if (completed) {
    return (
      <div className="token-access-container">
        <div className="token-access-card completed">
          <div className="icon-success">✓</div>
          <h2>Questionnaire Already Completed</h2>
          <p>This questionnaire has already been submitted.</p>
          {submittedAt && (
            <p className="submitted-date">
              Submitted on: {new Date(submittedAt).toLocaleString('en-IN', {
                timeZone: 'Asia/Kolkata',
                dateStyle: 'medium',
                timeStyle: 'short'
              })}
            </p>
          )}
          <div className="info-box">
            <p><strong>Note:</strong> Each questionnaire can only be submitted once.</p>
            <p>If you need to make changes or have questions, please contact support.</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="token-access-container">
        <div className="token-access-card error">
          <div className="icon-error">✕</div>
          <h2>Access Denied</h2>
          <p className="error-message">{error}</p>
          <div className="info-box">
            <p><strong>Possible reasons:</strong></p>
            <ul>
              <li>The link has expired (links are valid for 30 days)</li>
              <li>The questionnaire has already been completed</li>
              <li>The link is invalid or malformed</li>
            </ul>
            <p>Please contact support if you believe this is an error.</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default TokenAccess;
